/**
 * Z-Index Constants
 *
 * Centralized z-index management for consistent layering across the application.
 *
 * Hierarchy:
 * - 0-10: Base elements, timeline indicators
 * - 20-30: Table rows
 * - 35-45: Headers, navigation, fixed actions
 * - 50-60: Sidebar (with user menu), dropdowns, tooltips, pickers
 * - 65-80: Modal backdrops and modals (primary, secondary, tertiary)
 * - 85-99: Floating action buttons
 * - 100+: System-level notifications and alerts
 */

export const Z_BASE = 0;

// Timeline and indicators (10-19)
export const Z_TIMELINE_INDICATOR = 10;

// Table elements (20-29)
export const Z_TABLE_ROW = 20;

// Sidebar and navigation (30-39)
export const Z_SIDEBAR = 50;
export const Z_HEADER = 35;

// Sticky headers and bottom navigation (40-49)
export const Z_STICKY_HEADER = 40;
export const Z_BOTTOM_NAV = 40;
export const Z_FIXED_ACTION = 45;

// Dropdowns, tooltips, and interactive elements (50-64)
export const Z_DROPDOWN = 50;
export const Z_TOOLTIP = 55;
export const Z_USER_MENU_BACKDROP = 58;
export const Z_USER_MENU = 60;
export const Z_PICKER = 60;

// Modals and overlays (65-84)
export const Z_MODAL_BACKDROP = 65;
export const Z_MODAL = 70;
export const Z_MODAL_SECONDARY = 75;
export const Z_BOTTOM_SHEET_BACKDROP = 78;
export const Z_BOTTOM_SHEET = 80;
export const Z_MODAL_TERTIARY = 82;

// Floating action buttons (85-99)
export const Z_FAB = 85;

// System-level notifications (100+)
export const Z_TOAST = 100;
export const Z_NETWORK_BANNER = 100;

// Special case: Generic dropdown menu component (maintains existing behavior)
export const Z_DROPDOWN_MENU_TOP = 9999;
